module.exports = __webpack_public_path__ + "img/banner4.3a9cce3c.jpg";